import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { db, isFirebaseConfigured } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const DONE_KEY = 'sm_onboarding_done';
const FAV_KEY  = 'sm_fav_sports';

function readFavs() {
  try { return JSON.parse(localStorage.getItem(FAV_KEY)) || ['walking']; } catch { return ['walking']; }
}

export function useFavoriteSports() {
  const { user } = useAuth();
  const [done, setDone]           = useState(() => !!localStorage.getItem(DONE_KEY));
  const [favorites, setFavorites] = useState(readFavs);
  const [checked, setChecked]     = useState(false); // finished checking Firestore

  // When user logs in check if they have saved favorites in Firestore → skip onboarding
  useEffect(() => {
    if (!user?.uid || !isFirebaseConfigured || !db) { setChecked(true); return; }
    getDoc(doc(db, 'users', user.uid))
      .then(snap => {
        const favs = snap.data()?.favoriteSports;
        if (favs?.length > 0) {
          localStorage.setItem(DONE_KEY, '1');
          localStorage.setItem(FAV_KEY, JSON.stringify(favs));
          setFavorites(favs);
          setDone(true);
        }
      })
      .catch((err) => console.warn('[useFavoriteSports] Firestore load failed:', err))
      .finally(() => setChecked(true));
  }, [user]);

  // Guest: no Firestore check needed
  useEffect(() => {
    if (!user) setChecked(true);
  }, [user]);

  function toggle(id) {
    setFavorites(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  }

  async function complete() {
    localStorage.setItem(DONE_KEY, '1');
    localStorage.setItem(FAV_KEY, JSON.stringify(favorites));
    if (user?.uid && isFirebaseConfigured && db) {
      await setDoc(doc(db, 'users', user.uid), { favoriteSports: favorites }, { merge: true });
    }
    setDone(true);
  }

  function skip() {
    localStorage.setItem(DONE_KEY, '1');
    setDone(true);
  }

  return { done, checked, favorites, toggle, complete, skip };
}
